// Burger -----------------------------------------------------------------------------------------------------------------------
let menuBtn = document.querySelector('.menu-btn');
let menu = document.querySelector('.menu');
let menuLinks = document.querySelectorAll('.menu a');
let fixedBuyNow = document.querySelectorAll('.hidde-btn');

menuBtn.addEventListener('click', function () {
  menuBtn.classList.toggle('active');
  menu.classList.toggle('active');

  if (menu.classList.contains('active')) {
    document.body.style.overflow = 'hidden';
    fixedBuyNow.forEach((btn) => (btn.style.display = 'none'));
  } else {
    document.body.style.overflow = '';
    fixedBuyNow.forEach((btn) => (btn.style.display = 'block'));
  }
});

// ------------------------------------------------------------------------------------------------------------------------------

// Accordion --------------------------------------------------------------------------------------------------------------------
const items = document.querySelectorAll('.accordion button');

function toggleAccordion() {
  event.preventDefault();
  const itemToggle = this.getAttribute('aria-expanded');

  items.forEach((item) => {
    item.setAttribute('aria-expanded', 'false');
    item.nextElementSibling.style.maxHeight = '0';
    item.nextElementSibling.style.opacity = '0';
    item.querySelector('img').classList.remove('rotate-180');
  });

  // Відкриття елемента при кліку
  if (itemToggle === 'false') {
    this.setAttribute('aria-expanded', 'true');
    this.nextElementSibling.style.maxHeight = this.nextElementSibling.scrollHeight + 'px';
    this.nextElementSibling.style.opacity = '1';
    this.querySelector('img').classList.add('rotate-180');
  }
}
items.forEach((item) => item.addEventListener('click', toggleAccordion));
// ------------------------------------------------------------------------------------------------------------------------------
